import { render, staticRenderFns } from "./IndividualScore.vue?vue&type=template&id=e966133c&scoped=true&"
import script from "./IndividualScore.vue?vue&type=script&lang=js&"
export * from "./IndividualScore.vue?vue&type=script&lang=js&"
import style0 from "./IndividualScore.vue?vue&type=style&index=0&id=e966133c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e966133c",
  null
  
)

export default component.exports